import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef, MatDialog as MatDialog } from '@angular/material/dialog';
import { AddComponent } from './add/add.component';
import { UserService } from '../../../../auth-client/services/user.service';

@Component({
    selector: 'brover-delivery-adres-dialog',
    templateUrl: './delivery-adres-dialog.component.html',
    styleUrls: ['./delivery-adres-dialog.component.sass'],
    standalone: false
})
export class DeliveryAdresDialogComponent implements OnInit {

  public company: any;
  public addresses: string[] = [];

  public filter = '';
  public addressesFilterd: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {company: any, selected: string},
    public dialogRef: MatDialogRef<DeliveryAdresDialogComponent>,
    public dialog: MatDialog,
    public userService: UserService,
  ) { }
  ngOnInit(): void {
    this.getCompany();
  }

  getCompany() {
    this.userService.getCompanyInfo().subscribe(x => {
      if (x['success']) {
        const data = x['data'];
        console.log(data);
        this.company = data.dbCompany;

        this.addresses = [
          this.data.company.Straat +  ' - ' + this.data.company.Postcode +  ' - ' + this.data.company.Woonplaats
        ];

        this.addressesFilterd = [];
        if (this.data.company.Straat.includes(this.filter) || this.data.company.Postcode.includes(this.filter) ||
              this.data.company.Woonplaats.includes(this.filter)) {
          this.addressesFilterd.push(this.data.company.Straat +  ' - ' + this.data.company.Postcode + ' - ' + this.data.company.Woonplaats);
        }
        // tslint:disable-next-line:no-shadowed-variable
        data.dbCompany.addresses.forEach(x => {
          console.log(x);
          // tslint:disable-next-line:max-line-length
          this.addresses.push(x.address +  ' - ' + x.postalCode + ' - ' + x.city + ' - ' + (x.customerName !== null ? x.customerName : 'ree')  + ' - ' +  (x.customerCompanyName !== null ? x.customerCompanyName : 'ree'));

          if (x.address.includes(this.filter) || x.postalCode.includes(this.filter) || x.city.includes(this.filter)) {
            // tslint:disable-next-line:max-line-length
            this.addressesFilterd.push(x.address +  ' - ' + x.postalCode + ' - ' + x.city + ' - ' + (x.customerName !== null ? x.customerName : '')  + ' - ' +  (x.customerCompanyName !== null ? x.customerCompanyName : ''));
          }
        });
      }
    });
  }

  doFilter() {
    const filter = this.filter.toLowerCase();
    this.addressesFilterd = [];

    this.addresses.forEach(x => {
      if (x.toLowerCase().includes(filter)) {
        this.addressesFilterd.push(x);
      }
    });
  }

  radioChange(event: {value: string}) {
    this.dialogRef.close(event.value);
  }

  addAddress(): void {
    const dialogRef = this.dialog.open(AddComponent);
    dialogRef.afterClosed().subscribe(() => {
      this.getCompany();
    });
  }
}
